var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65205 4.17676V14.4145L1.01864 5.4437C0.983672 5.32207 0.998278 5.19154 1.05927 5.08065C1.12026 4.96975 1.22267 4.88752 1.34412 4.85192L3.65205 4.17676Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.095 21.1338H5.62103L6.11059 22.8042C6.14734 22.9254 6.23033 23.0272 6.34159 23.0876C6.45286 23.148 6.58343 23.1622 6.70506 23.127L11.6975 21.6583",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2173 21.2145C13.1667 21.1902 13.1173 21.1632 13.0694 21.1338",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2562 2.0946H10.748L14.4331 1.01864C14.5548 0.983672 14.6853 0.998278 14.7962 1.05927C14.9071 1.12026 14.9893 1.22267 15.0249 1.34412L15.2562 2.0946Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2501 10.4953V2.57084C18.2501 2.44457 18.1999 2.32346 18.1106 2.23418C18.0214 2.14489 17.9003 2.09473 17.774 2.09473H4.12815C4.00188 2.09473 3.88078 2.14489 3.79149 2.23418C3.7022 2.32346 3.65204 2.44457 3.65204 2.57084V20.6577C3.65204 20.784 3.7022 20.9051 3.79149 20.9944C3.88078 21.0836 4.00188 21.1338 4.12815 21.1338H11.095M16.351 5.42213C16.3518 5.50018 16.3323 5.57709 16.2945 5.64539C16.2548 5.72219 16.1945 5.78647 16.1205 5.8311C16.0464 5.87573 15.9614 5.89897 15.8749 5.89824H6.03529C5.91136 5.89474 5.79369 5.84303 5.70729 5.75412C5.62089 5.66521 5.57257 5.5461 5.57262 5.42213V4.47259C5.57333 4.34654 5.62372 4.22585 5.71285 4.13671C5.80199 4.04758 5.92268 3.99719 6.04874 3.99648H15.8749C16.001 3.99719 16.1217 4.04758 16.2108 4.13671C16.2999 4.22585 16.3503 4.34654 16.351 4.47259V5.42213Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.351 4.4722V5.42174C16.3518 5.49979 16.3323 5.57671 16.2946 5.645C16.2548 5.7218 16.1945 5.78608 16.1205 5.83071C16.0464 5.87535 15.9614 5.89858 15.8749 5.89785H6.03529C5.91137 5.89435 5.79369 5.84264 5.70729 5.75373C5.62089 5.66482 5.57258 5.54571 5.57263 5.42174V4.4722C5.57334 4.34615 5.62373 4.22546 5.71286 4.13632C5.802 4.04719 5.92269 3.9968 6.04874 3.99609H15.8749C16.001 3.9968 16.1217 4.04719 16.2108 4.13632C16.2999 4.22546 16.3503 4.34615 16.351 4.4722V4.4722Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3681 9.07471H11.9047",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4756 10.3418H9.36542",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3344 11.6113H9.36542",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1106 11.0601C6.1106 11.2016 6.15256 11.34 6.23118 11.4576C6.3098 11.5753 6.42155 11.667 6.55229 11.7212C6.68304 11.7753 6.8269 11.7895 6.9657 11.7619C7.10449 11.7343 7.23199 11.6661 7.33205 11.5661C7.43212 11.466 7.50026 11.3385 7.52787 11.1997C7.55548 11.0609 7.54131 10.917 7.48715 10.7863C7.433 10.6556 7.34129 10.5438 7.22363 10.4652C7.10596 10.3866 6.96762 10.3446 6.82611 10.3446C6.68459 10.3446 6.54626 10.3026 6.42859 10.224C6.31093 10.1454 6.21922 10.0336 6.16506 9.9029C6.11091 9.77216 6.09674 9.62829 6.12434 9.4895C6.15195 9.3507 6.2201 9.22321 6.32016 9.12314C6.42023 9.02308 6.54772 8.95493 6.68652 8.92732C6.82531 8.89971 6.96918 8.91388 7.09992 8.96804C7.23067 9.0222 7.34241 9.1139 7.42103 9.23157C7.49966 9.34923 7.54162 9.48757 7.54162 9.62909",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82886 8.91361V8.4375",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82886 12.2515V11.7754",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1106 17.4053C6.1106 17.5468 6.15256 17.6852 6.23118 17.8028C6.3098 17.9205 6.42155 18.0122 6.55229 18.0664C6.68304 18.1205 6.8269 18.1347 6.9657 18.1071C7.10449 18.0795 7.23198 18.0113 7.33205 17.9113C7.43212 17.8112 7.50026 17.6837 7.52787 17.5449C7.55548 17.4061 7.54131 17.2623 7.48715 17.1315C7.433 17.0008 7.34129 16.889 7.22363 16.8104C7.10596 16.7318 6.96762 16.6898 6.82611 16.6898C6.68448 16.6898 6.54604 16.6478 6.42831 16.569C6.31059 16.4903 6.21888 16.3784 6.16481 16.2475C6.11073 16.1166 6.09672 15.9726 6.12455 15.8337C6.15237 15.6949 6.22079 15.5674 6.32112 15.4674C6.42146 15.3674 6.5492 15.2995 6.68817 15.2722C6.82715 15.2449 6.9711 15.2595 7.10179 15.314C7.23249 15.3686 7.34405 15.4607 7.42234 15.5787C7.50064 15.6968 7.54215 15.8354 7.54162 15.977",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82886 15.2615V14.7827",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82886 18.5999V18.1211",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8619 24.0038C25.0734 24.2278 25.1893 24.5254 25.1849 24.8334C25.1805 25.1414 25.0562 25.4356 24.8383 25.6534C24.6205 25.8712 24.3264 25.9955 24.0183 25.9999C23.7103 26.0043 23.4127 25.8885 23.1888 25.677L20.0497 22.5486L21.7255 20.8755L24.8619 24.0038Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2951 21.2924L20.4612 22.1209L18.9791 20.6388C19.1297 20.5151 19.2776 20.386 19.4229 20.2434C19.5614 20.1041 19.6917 19.9568 19.8129 19.8022L21.2951 21.2924Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4229 12.706C19.0772 12.3574 18.6831 12.0603 18.2528 11.8238C18.1964 11.7915 18.1399 11.7592 18.0807 11.7296C17.3752 11.3719 16.5994 11.1748 15.8087 11.1525C15.0181 11.1302 14.2324 11.2832 13.5079 11.6005C12.9081 11.8695 12.3614 12.2439 11.8939 12.706C11.1541 13.4445 10.6488 14.3849 10.4414 15.4094C10.3579 15.8272 10.3236 16.2533 10.3392 16.679C10.394 18.0175 10.9476 19.2869 11.8912 20.2378C12.2412 20.5857 12.6377 20.8836 13.0694 21.1227C13.1173 21.1522 13.1667 21.1791 13.2174 21.2034C14.1304 21.6745 15.1602 21.8713 16.1825 21.7701C17.2049 21.6689 18.1762 21.2741 18.9791 20.6332C19.1297 20.5094 19.2777 20.3803 19.4229 20.2378C19.5615 20.0984 19.6917 19.9511 19.813 19.7966C20.6325 18.7741 21.0459 17.4852 20.974 16.1767C20.902 14.8683 20.3497 13.6325 19.4229 12.706V12.706ZM18.3766 19.2021C18.3386 19.2424 18.2972 19.2793 18.2528 19.3124C17.5249 19.9855 16.5642 20.3501 15.573 20.3296C14.5817 20.309 13.637 19.9049 12.9376 19.2021C12.5803 18.8476 12.2977 18.425 12.1064 17.9594C11.9363 17.5566 11.8397 17.1266 11.8213 16.6898C11.7931 16.2618 11.8395 15.8322 11.9585 15.4201C12.1409 14.7945 12.4776 14.2248 12.9376 13.7632C13.637 13.0609 14.5811 12.6567 15.5719 12.6351C16.5628 12.6136 17.5236 12.9764 18.2528 13.6475C18.2973 13.6825 18.3387 13.7212 18.3766 13.7632C18.5492 13.9327 18.7042 14.1192 18.8392 14.32C19.3392 15.0615 19.5664 15.9535 19.4821 16.8439C19.3977 17.7343 19.007 18.5677 18.3766 19.2021Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsIcon);
export default __webpack_public_path__ + "static/media/contracts-icon.02b7a66e75f8e08382c6d867a8478543.svg";
export { ForwardRef as ReactComponent };